import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRevenueCode extends Layout {
    sourceRevenueCode: DataSource;
    textboxDescr: Textbox;
    textboxExpenseGlid: Textbox;
    textboxId: Textbox;
    textboxOrderMode: Textbox;
    textboxRevenueGlid: Textbox;
}
